function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.0209 12.2032C11.1331 12.744 11.6625 13.0914 12.2032 12.9791C12.744 12.8669 13.0914 12.3375 12.9791 11.7968C12.8669 11.256 12.3375 10.9086 11.7968 11.0209C11.256 11.1331 10.9086 11.6625 11.0209 12.2032Z",
  fill: "white",
  fillOpacity: 0.87
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.784 6.84174C17.9837 7.06566 18.0307 7.38703 17.9036 7.65878L14.676 14.5568C14.5891 14.7427 14.4297 14.8849 14.2351 14.9501L7.01403 17.3702C6.72956 17.4655 6.41565 17.3822 6.21596 17.1582C6.01627 16.9343 5.96924 16.613 6.09638 16.3412L9.32393 9.44317C9.41091 9.25725 9.5703 9.11511 9.76491 9.04989L16.9859 6.62981C17.2704 6.53447 17.5843 6.61783 17.784 6.84174ZM10.5463 10.37L8.19666 15.3918L13.4536 13.63L15.8033 8.60816L10.5463 10.37Z",
  fill: "white",
  fillOpacity: 0.87
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75Z",
  fill: "white",
  fillOpacity: 0.87
});

function SvgExplore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplore);
export default __webpack_public_path__ + "static/media/explore.0a3a69ee.svg";
export { ForwardRef as ReactComponent };